import { apiFetch } from "@/lib/api-client";

// GET /api/portal/journeys/attachments/:id/signed-url — mint a short-lived
// (1h) signed download URL for a journey task attachment. Called on click
// rather than embedded in the detail payload so URLs stay fresh.

export async function fetchJourneyTaskAttachmentUrl(
  attachmentId: string,
): Promise<string> {
  const result = await apiFetch<{ url: string; file_name: string }>(
    `/portal/journeys/attachments/${attachmentId}/signed-url`,
  );
  return result.url;
}
